export const replaceMeasurementSpaces = (html: string): string => {
  const units = [
    'кг',
    'г',
    'мг',
    'л',
    'литр',
    'литра',
    'литров',
    'см',
    'м',
    'км',
    'шт',
    'ккал',
    '°C',
    '°F',
    '%',
    'мл',
  ];

  const regex = new RegExp(
    `(\\d+(?:[.,]\\d+)?)[\\s\u202F\u00A0]?(${units.join('|')})(?![^<]*?>)`,
    'gi'
  );

  const parser = new DOMParser();
  const doc = parser.parseFromString(html, 'text/html');

  const walk = (node: Node) => {
    if (node.nodeType === Node.TEXT_NODE) {
      node.textContent = node.textContent?.replace(regex, '$1\u00A0$2') ?? '';
    } else if (
      node.nodeType === Node.ELEMENT_NODE &&
      node.childNodes.length > 0
    ) {
      node.childNodes.forEach(walk);
    }
  };

  walk(doc.body);
  return doc.body.innerHTML;
};

export const getPlainTextLength = (html: string) => {
  return html.replace(/<[^>]*>/g, '').trim().length;
};
